export const data = [
  {
    date: "6 Nov 2022",
    title: "Registration starts",
    description: "",
  },
  {
    date: "21 Nov 2022",
    title: "Registration ends",
    description: "",
    flag: true,
  },
  {
    date: "25 Nov 2022",
    title: "Tek-O-thon",
    description: "",
  },
  {
    date: "26 Nov 2022",
    title: "Tek-O-thon ends",
    description: "",
    flag: true,
  },
  {
    date: "29 Nov 2022",
    title: "Shortlist announcement",
    description: "",
  },
  {
    date: "3 Dec 2022",
    title: "Prize Distribution",
    description: "",
    flag: true,
  },
];
